import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  profile: {},
  notificationCount: 0,
  friendRequestsCount: 0,
  familyMemberss: {},
  loading: false,
  error: "",
};

const profile = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileLoading(state) {
      state.loading = true;
      state.error = "";
    },
    setProfileSuccess(state, action) {
      state.profile = action.payload;
      state.loading = false;
    },
    setProfileFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setUserNotificationCountLoading(state) {
      state.loading = true;
      state.error = "";
    },
    setUserNotificationCountSuccess(state, action) {
      state.notificationCount = action.payload;
      state.loading = false;
    },
    setUserNotificationCountFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setFamilyMembersLoading(state) {
      state.loading = true;
      state.error = "";
    },
    setFamilyMembersSuccess(state, action) {
      state.familyMemberss = action.payload;
      state.loading = false;
    },
    setFamilyMembersFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setPendingFriendRequestsCountLoading(state) {
      state.loading = true;
      state.error = "";
    },
    setPendingFriendRequestsCountSuccess(state, action) {
      state.friendRequestsCount = action.payload;
      state.loading = false;
    },
    setPendingFriendRequestsCountFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  setProfileLoading,
  setProfileSuccess,
  setProfileFail,
  setUserNotificationCountLoading,
  setUserNotificationCountSuccess,
  setUserNotificationCountFail,
  setFamilyMembersLoading,
  setFamilyMembersSuccess,
  setFamilyMembersFail,
  setPendingFriendRequestsCountLoading,
  setPendingFriendRequestsCountSuccess,
  setPendingFriendRequestsCountFail,
} = profile.actions;
export default profile.reducer;
